enum Direction {
	Back = 1,
	Right = 2,
	Front = 3,
	Left = 4,
	Top = 5,
	Bottom = 6
}

export { Direction }